import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

const [useSaveMultipleAssetTags, saveMultipleAssetTags] = createAsyncAction(
  "assets/saveMultipleAssetTags",
  async (updates: { uuid: string; keywords: string }[]) => {
    const res = await API.call<{ assets: string }>({
      endpoint: "sync/assets",
      method: "POST",
      data: { assets: updates },
    });
    return { ...res, result: res.result.assets };
  }
);

export default useSaveMultipleAssetTags;
export { saveMultipleAssetTags };
